import { Box, Grid } from '@mui/material';
import MediaField from 'Components/Forms/MediaField';
import TextInputField from 'Components/Forms/TextInputField';
import { FieldWrapper } from 'DesignSystem';
import HasAccess from 'Components/HasAccess';
import { FastField as Field } from 'formik';
import React, { FC } from 'react';
import { ECustomerPlan } from 'FeatureModules/Auth/types/company.types';
import CountryMultiselectField from 'Components/Forms/CountryMultiselectField';

const CompanyFields: FC = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextInputField label="Company name" name="name" />
          </Grid>
          <Grid item xs={12}>
            <TextInputField
              label="EORI number"
              name="eoriNumber"
              placeholder='e.g. "DE123456789012345678"'
              helperText="If you import or export goods into or out of the European Union (EU), you will need to add your company EORI number. This number is valid throughout the EU. It is used as a common reference number for interactions with the customs authorities in any EU member State."
            />
          </Grid>
          <Grid item xs={12}>
            <TextInputField
              label="VAT number"
              name="vatNumber"
              placeholder='e.g. "DE123456789"'
              helperText="If you import or export goods into or out of the European Union (EU), you will need to add your company tax identification number (VAT). In the EU, a VAT identification number can be verified online at the EU's official VIES website. It confirms that the number is currently allocated and can provide the name or other identifying details of the entity to whom the identifier has been allocated."
            />
          </Grid>
          <Grid item xs={12}>
            <TextInputField
              multiline
              maxlength={300}
              maxRows={5}
              minRows={3}
              placeholder='e.g. "We are a company that specializes in..."'
              label="Description"
              name="description"
              helperText="Briefly describe what your company does, including key products, services, areas of expertise and daily activities. Keep it short and clear—this will help others quickly understand your business."
            />
          </Grid>
          <Grid item xs={12}>
            <TextInputField
              label="Company Website"
              name="website"
              placeholder="https://website.com"
            />
          </Grid>
          <Grid item xs={12}>
            <FieldWrapper label="Countries of Business">
              <CountryMultiselectField
                name="countriesOfBusiness"
                placeholder="Select countries"
                showCountryRisk
                size="medium"
                label=""
                data-testid="countries-of-business"
              />
            </FieldWrapper>
          </Grid>
          <HasAccess allowedPlans={[ECustomerPlan.PAYING, ECustomerPlan.INTERNAL]}>
            <Grid item xs={12}>
              <TextInputField
                label="Online Shop (optional)"
                name="onlineShop"
                placeholder="https://onlineshop.com"
              />
            </Grid>
          </HasAccess>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <FieldWrapper label="Company logo">
          <Field
            cropDisabled
            component={MediaField}
            fullWidth
            singleUpload
            legacyImage={false}
            name="logo"
            data-testid="company-logo-field"
            styles={{
              width: 200,
              height: 200,
            }}
          />
        </FieldWrapper>
      </Grid>
      <HasAccess allowedPlans={[ECustomerPlan.PAYING, ECustomerPlan.INTERNAL]}>
        <Grid item xs={12}>
          <Box mt={1} mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextInputField
                  label="Facebook"
                  name="social.facebook"
                  placeholder="https://facebook.com/yourcompany"
                />
              </Grid>
              <Grid item xs={6}>
                <TextInputField
                  label="Instagram"
                  name="social.instagram"
                  placeholder="https://instagram.com/yourcompany"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </HasAccess>
    </Grid>
  );
};

export default CompanyFields;
